var app = angular.module("myApp", ['templateCacher', 'ui.bootstrap', 'angular-jwt', 'ngRoute', 'ngCookies', 'ngMessages', 'ngFileUpload', 'ngCookies', 'signature', 'webcam', 'pascalprecht.translate', , 'angular.filter', 'ng.deviceDetector', 'imgEditor.directives', 'ng-webcam']);


app.run(['$rootScope', function ($rootScope, jwtHelper, $location, $window, $http) {
    $rootScope.GlobalAlert = function (type, title, text) {
        return swal({
            type: type,
            title: title,
            text: text,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            backdrop: true,
            width: '20%',
            grow: 'fullscreen',
        })
    };

    $rootScope.AlertYesNo = function (type, title, text) {
        return swal({
            type: type,
            title: title,
            text: text,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonClass: 'btn btn-success',
            focusConfirm: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: true,
        })
    };

    $rootScope.AlertShowLoading = function (type, title, text, timer) {
        return swal({
            type: type,
            title: title,
            text: text,
            timer: timer,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            onOpen: () => {
                swal.showLoading()
            }
        })
    };

    //$rootScope.timeout = function () {
    //    $http({
    //        method: 'POST',
    //        url: '/service/client.svc/retrieveSession',
    //    }).then(function (data) {
    //        if (!data.data.d) {
    //            $http({
    //                method: 'GET',
    //                url: '/service/client.svc/SignOut',
    //            }).then(function (data) {
    //                if (data.data.d == true) {
    //                    $window.location.href = "#/login";
    //                    swal('Error', 'SESSION EXPIRED', 'error');
    //                }
    //            }, function (error) { })
    //        }
    //        else
    //            $scope.currentUser = data.data.d;
    //    }, function (error) { });
    //}

}]);



app.config(function ($provide, $routeProvider, $locationProvider, $httpProvider, jwtInterceptorProvider, $translateProvider) {
    $locationProvider.hashPrefix('');
    $routeProvider.
	when('/',
	{
	    templateUrl: 'login.html',
	    controller: 'LoginCtrl'
	}).
    when('/register',
	{
	    templateUrl: 'register.html',
	    controller: 'RegisterCtrl'
	}).
    when('/register/:id',
	{
	    templateUrl: 'register.html',
	    controller: 'RegisterCtrl'
	}).
    when('/activation/:generatedkey',
	{
	    templateUrl: 'register.html',
	    controller: 'ActivationCtrl'
	}).
    when('/forgetpassword',
	{
	    templateUrl: 'forgetPassword.html',
	    controller: 'forgetPasswordCtrl'
	}).
    when('/change_password/:ResetPasswordKey',
	{
	    templateUrl: 'changePassword.html',
	    controller: 'changePasswordCtrl'
	}).
    when('/login',
	{
	    templateUrl: 'login.html',
	    controller: 'LoginCtrl'
	}).
    when('/preparation',
	{
	    templateUrl: 'Preparation.html',
	    controller: 'PreparationCtrl'
	}).
    when('/FAQ',
	{
	    templateUrl: 'FAQ.html',
	    controller: 'FAQCtrl'
	}).
    when('/cif/data-pribadi',
	{
	    templateUrl: 'CIF-1.html',
	    controller: 'CIF-CTRL'
	}).
    when('/cif/data-pekerjaan',
	{
	    templateUrl: 'CIF-2.html',
	    controller: 'CIF2-CTRL'
	}).
    when('/cif/data-benef',
	{
	    templateUrl: 'CIF-Benef.html',
	    controller: 'CIFBenef-CTRL'
	}).
    when('/cif/data-pendukung',
	{
	    templateUrl: 'CIF-3.html',
	    controller: 'CIF3-CTRL'
	}).
    when('/cif/data-pernyataan',
	{
	    templateUrl: 'CIF-4.html',
	    controller: 'CIF4-CTRL'
	}).
    when('/dashboard',
	{
	    templateUrl: 'dashboard/dashboard.html',
	    controller: 'CIFDashboard-CTRL'
	}).
    when('/profile',
	{
	    templateUrl: 'dashboard/profile.html',
	    controller: 'CIFProfile-CTRL'
	}).
	otherwise(
	{
	    redirectTo: '/logout'
	});

    $translateProvider.useStaticFilesLoader({
        prefix: '/lang/locale-',
        suffix: '.json'
    });
    $translateProvider.preferredLanguage('en');
});


app.factory('S21Language', function () {
    var lang = '';
    return {
        getLang: function () {
            return lang;
        },

        setLang: function (value) {
            lang = value;
            return value;
        }
    };
});

app.factory('KTPCamService', function () {
    var webcam = {};
    webcam.isTurnOn = false;
    webcam.patData = null;
    var _video = null;
    var _stream = null;
    webcam.patOpts = { x: 0, y: 0, w: 25, h: 25 };
    webcam.channel = {};
    webcam.webcamError = false;

    var getVideoData = function getVideoData(x, y, w, h) {
        var hiddenCanvas = document.createElement('canvas');
        hiddenCanvas.width = _video.width;
        hiddenCanvas.height = _video.height;
        var ctx = hiddenCanvas.getContext('2d');
        ctx.drawImage(_video, 0, 0, _video.width, _video.height);
        return ctx.getImageData(x, y, w, h);
    };

    var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
        webcam.snapshotData = imgBase64;
    };

    webcam.makeSnapshot = function () {
        if (_video) {
            var patCanvas = document.querySelector('#KTPsnapshot');
            if (!patCanvas) return;

            patCanvas.width = _video.width;
            patCanvas.height = _video.height;
            var ctxPat = patCanvas.getContext('2d');

            var idata = getVideoData(webcam.patOpts.x, webcam.patOpts.y, webcam.patOpts.w, webcam.patOpts.h);
            ctxPat.putImageData(idata, 0, 0);

            sendSnapshotToServer(patCanvas.toDataURL());

            webcam.patData = idata;

            webcam.success(webcam.snapshotData.substr(webcam.snapshotData.indexOf('base64,') + 'base64,'.length), 'image/png');
            //webcam.turnOff();
        }
    };

    webcam.onSuccess = function () {
        _video = webcam.channel.video;
        webcam.patOpts.w = _video.width;
        webcam.patOpts.h = _video.height;
        webcam.isTurnOn = true;
    };

    webcam.onStream = function (stream) {
        activeStream = stream;
        console.log('kt', activeStream);
        return activeStream;
    };

    webcam.downloadSnapshot = function downloadSnapshot(dataURL) {
        window.location.href = dataURL;
    };

    webcam.onError = function (err) {
        webcam.webcamError = err;
    };

    webcam.turnOff = function () {
        webcam.isTurnOn = false;
        if (activeStream && activeStream.getVideoTracks) {
            const checker = typeof activeStream.getVideoTracks === 'function';
            if (checker) {
                console.log('ktp', activeStream.getVideoTracks());
                return activeStream.getVideoTracks()[0].stop();
            }
            return false;
        }
        return false;
    };

    var service = {
        webcam: webcam
    };
    return service;
});


app.factory('SELFIECamService', function () {
    var webcam = {};
    webcam.isTurnOn = false;
    webcam.patData = null;
    var _video = null;
    var _stream = null;
    webcam.patOpts = { x: 0, y: 0, w: 25, h: 25 };
    webcam.channel = {};
    webcam.webcamError = false;

    var getVideoData = function getVideoData(x, y, w, h) {
        var hiddenCanvas = document.createElement('canvas');
        hiddenCanvas.width = _video.width;
        hiddenCanvas.height = _video.height;
        var ctx = hiddenCanvas.getContext('2d');
        ctx.drawImage(_video, 0, 0, _video.width, _video.height);
        return ctx.getImageData(x, y, w, h);
    };

    var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
        webcam.snapshotData = imgBase64;
    };

    webcam.makeSnapshot = function () {
        if (_video) {
            var patCanvas = document.querySelector('#SELFIEsnapshot');
            if (!patCanvas) return;

            patCanvas.width = _video.width;
            patCanvas.height = _video.height;
            var ctxPat = patCanvas.getContext('2d');

            var idata = getVideoData(webcam.patOpts.x, webcam.patOpts.y, webcam.patOpts.w, webcam.patOpts.h);
            ctxPat.putImageData(idata, 0, 0);

            sendSnapshotToServer(patCanvas.toDataURL());

            webcam.patData = idata;

            webcam.success(webcam.snapshotData.substr(webcam.snapshotData.indexOf('base64,') + 'base64,'.length), 'image/png');
            //webcam.turnOff();
        }
    };

    webcam.onSuccess = function () {
        _video = webcam.channel.video;
        webcam.patOpts.w = _video.width;
        webcam.patOpts.h = _video.height;
        webcam.isTurnOn = true;
    };

    webcam.onStream = function (stream) {
        activeStream = stream;
        console.log('se', activeStream);
        return activeStream;
    };

    webcam.downloadSnapshot = function downloadSnapshot(dataURL) {
        window.location.href = dataURL;
    };

    webcam.onError = function (err) {
        webcam.webcamError = err;
        console.log('ERR', webcam.webcamError)
    };

    webcam.turnOff = function () {
        webcam.isTurnOn = false;
        if (activeStream && activeStream.getVideoTracks) {
            const checker = typeof activeStream.getVideoTracks === 'function';
            if (checker) {
                console.log('se', activeStream.getVideoTracks());
                return activeStream.getVideoTracks()[0].stop();
            }
            return false;
        }
        return false;
    };

    var service = {
        webcam: webcam
    };


    return service;
});



app.controller('HomeController', function ($scope, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $cookies, $translate) {
    $scope.login = {
        Username: '',
        Password: '',
        Email: '',
        Notelp: ''
    };

    $scope.login_status = false;

    $scope.languages = [
       {
           lang: 'en',
           name: 'English',
       },
       {
           lang: 'id',
           name: 'Indonesia'
       }
    ];

    $scope.languageSelected = $scope.languages[0];
    //$scope.language = 'en';

    $scope.updateLanguage = function (lang) {
        if (lang == 'id')
            $scope.languageSelected = $scope.languages[1];
        else
            $scope.languageSelected = $scope.languages[0];
        $translate.use($scope.languageSelected.lang);
        $cookies.put("lang", $scope.languageSelected.lang);
    };

    var allPromise = $q.all([
		 $http({
		     method: 'POST',
		     url: '/service/client.svc/retrieveSession',
		 }).then(function (data) {

		     if (data.data.d != null) {
		         $scope.login_status = true;
		         $scope.login = data.data.d;
		     }
		 }, function (error) { }),

    ]);

    

    $scope.signout = function () {
        $http({
            method: 'POST',
            url: '/service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };


    //$scope.getDateString = function (jsonDate) {
    //    if (jsonDate == undefined) {
    //        return "";
    //    }
    //    var utcTime = parseInt(jsonDate.substr(6));
    //    return utcTime;
    //}

    allPromise.then(function () {
        if (!$cookies.get('lang'))
            $cookies.put("lang", 'id');
        else
            $scope.updateLanguage($cookies.get('lang'));

    });
});



app.directive('numericOnly', function ($filter) {
    return {
        require: '?ngModel',
        link: function (scope, elem, attrs, ctrl) {
            if (!ctrl) {
                return;
            }

            ctrl.$formatters.unshift(function () {
                return $filter('number')(ctrl.$modelValue);
            });

            ctrl.$parsers.unshift(function (viewValue) {
                var plainNumber = viewValue.replace(/[^\d]/g, ''),
                    b = $filter('number')(plainNumber);

                elem.val(b);
                if (plainNumber == '') {
                    plainNumber = 0;
                }
                return parseInt(plainNumber);
            });
        }
    };
});

app.directive('textOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {

            ngModel.$parsers.push(function (value) {
                if (!value) return value;

                var clean = value.replace(/[^a-zA-Z\s]/g, '');
                if (clean !== value) {
                    ngModel.$setViewValue(clean);
                    ngModel.$render();
                }
                return clean;
            });
        }
    };
});


app.directive('numbersOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (value) {
                if (!value) return value;

                var clean = value.replace(/[^0-9]/g, '');
                if (clean !== value) {
                    ngModel.$setViewValue(clean);
                    ngModel.$render();
                }
                return clean;
            });
        }
    };
});

//app.directive('numbersOnly', function () {
//    return {
//        require: 'ngModel',
//        link: function (scope, element, attr, ngModelCtrl) {
//            function fromUser(text) {
//                if (text) {
//                    var transformedInput = text.replace(/[^0-9]/g, '');

//                    if (transformedInput !== text) {
//                        ngModelCtrl.$setViewValue(transformedInput);
//                        ngModelCtrl.$render();
//                    }
//                    return transformedInput;
//                }
//                return undefined;
//            }
//            ngModelCtrl.$parsers.push(fromUser);
//        }
//    };
//});


app.directive('onlyNumbers', function () {
    return {
        restrict: 'A',
        link: function (scope, elm, attrs, ctrl) {
            elm.on('keydown', function (event) {
                if (event.shiftKey) { event.preventDefault(); return false; }
                //console.log(event.which);
                if ([8, 13, 27, 37, 38, 39, 40].indexOf(event.which) > -1) {
                    // backspace, enter, escape, arrows
                    return true;
                } else if (event.which >= 48 && event.which <= 57) {
                    // numbers 0 to 9
                    return true;
                } else if (event.which >= 96 && event.which <= 105) {
                    // numpad number
                    return true;
                }
                    // else if ([110, 190].indexOf(event.which) > -1) {
                    //     // dot and numpad dot
                    //     return true;
                    // }
                else {
                    event.preventDefault();
                    return false;
                }
            });
        }
    }
});

app.controller('CameraController', function ($scope, $uibModalInstance, items, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $cookies, $translate) {

    $scope.items = items;
    $scope.camfacing = 'env';
    $scope.ktpPhoto = '';

    $scope.KTPconfig = {
        //viewerWidth: 300,
        //viewerHeight: 300,
        //outputWidth: 300,
        //outputHeight: 300,
        delay: 0,
        shots: 1,
        countdown: 0,
        flashFallbackUrl: 'vendors/webcamjs/webcam.swf',
        shutterUrl: 'shutter.mp3',
        flashNotDetectedText: 'Camera not found or use Chrome Browser'
    };

    $scope.switchCam = function () {
        console.log($scope.camfacing);
        if ($scope.camfacing == 'env') {
            console.log('cam1');
            $scope.$broadcast('ngWebcam_camUsr');
            $scope.camfacing = 'usr'
        }
        else {
            console.log('cam1');
            $scope.$broadcast('ngWebcam_camEnv');
            $scope.camfacing = 'env'
        }

        console.log($scope.camfacing);
    }

    $scope.KTPonCaptureComplete = function (src) {
        console.log(src);
        $scope.ktpPhoto = src[0];
        $uibModalInstance.close($scope.ktpPhoto);
        //var el = document.getElementById('result');
        //var img = document.createElement('img');
        //img.src = src[$scope.KTPconfig.shots - 1];
        //img.width = 240;
        //img.height = 180;
        //el.appendChild(img);
    };

    $scope.KTPonError = function (err) {
        //$log.error('webcamController.onError : ', err);
    };

    $scope.KTPonLoad = function () {
        // $log.info('ktp.onLoad');
    };

    $scope.KTPcapture = function () {
        $scope.$broadcast('ngWebcam_capture');
    };

    $scope.KTPon = function () {
        $scope.$broadcast('ngWebcam_on');
    };

    $scope.KTPoff = function () {
        $scope.$broadcast('ngWebcam_off');
        $scope.captureButtonEnable = false;
    };

    $scope.KTPremove = function () {
        $scope.ktpPhoto = '';
    }





    $scope.ok = function () {
        $uibModalInstance.close($scope.item);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };



});



app.controller('BrowseController', function ($scope, $uibModalInstance, items, uibDateParser, $http, $window, $location, $timeout, Upload, $q, $cookies, $translate) {

    $scope.items = items;
    $scope.allowedExt = ['.jpg', '.jpeg', '.bmp', '.png'];


    $scope.filenameKTP = "";
    $scope.fileKTP = "";
    $scope.fileKTPext = "";
    $scope.KTPFile = [];



    $scope.selectKTP = function (files) {

        if (files.length > 0) {
            console.log('files', files);
            $scope.KTPFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {
                if (allowed) {
                    $scope.fileKTP = btoa(e.target.result.toString());
                    $uibModalInstance.close($scope.fileKTP);
                }
            };
            console.log('gambar', $scope.KTPFile);
            reader.readAsBinaryString(files[0]);
            $scope.fileKTPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

            if ($scope.allowedExt.indexOf($scope.fileKTPext.toLowerCase()) < 0) {
                allowed = false;
                $scope.fileKTPext = '';
                $scope.KTPFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            }
            else
                $scope.filenameKTP = files[0].name;
        }
        else
            console.log('file not found');
    };


    $scope.clickRemoveKTP = function (file, event, key) {
        event.preventDefault();
        $scope.fileKTP = "";
        $scope.filenameKTP = "";
        $scope.fileKTPext = "x";
        $scope.KTPFile.splice(key, 1);
        $scope.KTPFile = [];
        return null;
    };
});